export const ServiceHost = 'https://service.coomwbank.com/api'